export default "__VITE_ASSET__BBqBDFPV__"